<!--
vData:传入数据
cd(type,eData,iscb): 事件回调
type:message/invite/details/collect/live ==> 消息/邀请/详情/收藏/直播
eData:{}返回的数据
iscb:是否触发回调 默认是true
插槽：vData 为插槽返回数据绑定属性
name="exhibitsInfo" ：自定义展品大图上的信息
name="footer" :自定义页脚
name="collect" :自定义收藏
-->
<template>
  <div class="v-exhibits-card v-exhibits-card-square text-left" @click.stop="cb('details', vData, true, index)">
    <div class="v-exhibits-header">
      <div class="img-box v-header-bg">
        <img v-lazy="$funcs.compressImage(firstImg, 300, 300)" :key="firstImg" alt="" class="lazy-img-fadein" />
      </div>
      <div class="v-exhibits-info">
        <slot name="exhibitsInfo" :vData="{}">
          <div class="v-info-top">
            <div class="flex">
              <slot name="che" v-if="vData['check']">
                <i class="el-icon-circle-check"></i>
              </slot>
              <div class="pointer zhibo-pointer" @click.stop="cb('live', vData, true, index)"
                v-if="vData['liveState'] && liveStatus">
                <span class="iconfont iconzhibo"></span>
                <span class="font-size-12">{{liveStatusText(vData.live)}}</span>
              </div>
              <div v-else></div>
            </div>
          </div>
          <template v-if="$store.state.config.hideElement">
            <div class="v-info-bottom text-right theme-icon-color font-size-14" v-if="vData['pageView']">
              <i class="el-icon-view"></i>&nbsp;&nbsp;<span>{{ vData['pageView'] }}</span>
            </div>
          </template>
        </slot>
      </div>
    </div>
    <div class="v-exhibits-body">
      <v-swiper :option="swiperOption" @callback="cb"></v-swiper>
      <div class="flex margin-tb-12" style="margin-bottom: 0">
        <div class="product-hot" v-if="vData['recommend']">{{ $t('finds.preferredExhibits') }}</div>
        <div class="v-exhibits-detail font-size-16 v-nowrap">
          <b>
            <slot name="productName">{{ vData.productName }}</slot>
          </b>
        </div>
        <div class="font-size-13 text-right" v-if="$store.state.config.hideElement">
          <slot name="collect" :vData="{}">
            <div class="pointer v-pointer-collected" @click.stop="cb('collect', vData, true, index)">
              <span class="iconfont theme-icon-color"
                :class="{ 'iconshoucang-xuanzhong': vData['collected'], iconshoucang: !vData['collected'] }"></span>
              <span>{{ vData['collected'] ? $t('collect[1]') : $t('collect[0]') }}</span>
            </div>
          </slot>
        </div>
      </div>
      <div class="tagList">
        <template v-for="(item, index) in vData['questionList'] || []">
          <template v-if="item.id != '4df3de85c5d039c265fe4d91bfeaad70'">
            <span class="theme-label" v-for="qItem in item['answerList']" :key="qItem.id + index">{{ qItem.aliasName
              }}</span>
          </template>
        </template>
      </div>
    </div>
    <div class="v-exhibits-footer flex-end align-center font-size-14">
      <slot name="footer" :vData="{}">
        <!-- <template v-if="$store.state.config.hideElement">
          <div class="pointer SmallBiao" @click.stop="cb('message', vData, true, index)">
            <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
            <span>{{ $t('message') }}</span>
          </div>
          <div class="pointer SmallBiao" @click.stop="cb('invite', vData, true, index)"
            :class="{ disabled: vData.invite }">
            <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
            <span>{{ vData.invite ? $t('finds.invited') : $t('invite') }}</span>
          </div>
        </template> -->
        <div class="pointer SmallBiao" @click.stop="cb('details', vData, true, index)">
          <span class="el-icon-tickets theme-icon-primary-color"></span>
          <span>{{ $t('details') }}</span>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import vSwiper from '@/components/vSwiper'
export default {
  props: {
    index: {
      type: Number,
      index: 0
    },
    vData: {
      type: [Object],
      default: () => {}
    },
    liveStatus: {
      type: Boolean,
      default: true
    },
    // 一屏显示几张图片
    slides: {
      type: Number,
      default: 6
    },
  },
  name: 'exhibitsCard',
  components: {
    vSwiper
  },
  data() {
    return {
      swiperOption: {
        imgW: '40px',
        imgH: '40px',
        slidesPerView: this.slides,
        list: [],
        active: 0
      },
      firstImg: ''
    }
  },
  watch: {
    'vData.id': function() {
      this.pageInit()
    }
  },
  mounted() {
    this.pageInit()
  },
  methods: {
    pageInit() {
      let _list = this.vData.iconUrl ? this.vData.iconUrl.split(',') : []
      let list = []
      if (this.vData.scope == 1 && this.vData.inPool == false) {
        this.firstImg = this.defImage('product1')
        this.swiperOption.list = this.minImageThree(list, 'product2')
      } else {
        _list.forEach(element => {
          if (element) {
            list.push(element)
          }
        })
        this.firstImg = list[0]
        this.swiperOption.list = this.minImageThree(list)
      }
    },
    cb(type, eData, iscb = true, index) {
      if (!iscb) return ''
      if (type.type == 'swiper' && type.data && type.data.item) {
        this.swiperOption.active = type.data.index
        this.firstImg = type.data.item
        return false
      }

      this.$emit('callback', { type: type, data: eData, iscb, index })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-exhibits-card{
    width:100%;
    transition: all .3s;

    .iconfont{
        margin-left:0;
        font-size: 16px;
    }
    .v-exhibits-header{
        position:relative;
        overflow: hidden;
        height: 195px;
        .v-exhibits-info{
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height :100%;
            background:linear-gradient(180deg,$color-white-00 0%, $color-black-25 100%);
            background:radial-gradient($color-black-10 10%, $color-black-25 140%)
            .v-info-top{
                padding:8px;
            }
            .v-info-bottom{
                position:absolute;
                top: 8px;
                right: 8px;
                padding: 4px 14px;
                line-height: 16px;
                background-color: $color-black-25
                color: #fff;
                font-size: 14px;
                border-radius: 4px;

                .el-icon-view{
                  margin-right: 5px;
                }
            }
        }
    }
    .v-exhibits-body{
        padding:12px 12px 0;
        background: $color-white;

        .v-exhibits-detail{
            max-width: 180px;
            line-height: 22px;
            height 22px;
            flex: 1
        }

        .exhibitionHall{
          margin-top: 5px;
          margin-bottom: 12px;
          font-size: 14px;
          line-height: 18px;
          color: $color-black-65;
        }
    }
    .v-exhibits-footer{
        background: $color-gray-f5;
        height:44px;
        padding:12px;
        >div + div{
            margin-left:20px;
        }
    }

    .tagList{
      overflow hidden
      .theme-label {
        margin-left: 0
        margin-right: 12px;
      }
    }

    .v-header-bg {
      transition: all .3s;
    }

    &:hover {
      box-shadow 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2
      transition 0.3s all
      .v-header-bg{
        transform: scale(1.2)
      }
    }
}
</style>
<style>
.v-pointer-collected {
  margin-top: 2px;
}
</style>
